<div class="preferences-container">
  <div class="yoka-header">
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <div class="yoka-brand">
            <span class="yoka">YOKASTAR</span>
          </div>
        </div>
        <div class="col-lg-6" style="text-align: right;">
          <p class="yoka-tagline" style="line-height: 3;">Personnalisez votre expérience</p>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    

    <div class="header">
      <h2>Mes domaines d'Intérêt</h2>
      <p class="subtitle">Sélectionnez vos domaines préférés ({{selectedCount}}/{{maxSelections}} maximum)</p>
    </div>

    <div class="content">
      <div *ngIf="loading" class="spinner-overlay">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Chargement...</span>
        </div>
      </div>

      <div *ngIf="error" class="error-message">
        {{error}}
      </div>

      <div class="categories-grid" *ngIf="!loading && !error">
        <div 
          *ngFor="let category of categories" 
          class="category-card"
          [class.selected]="category.selected"
          [class.disabled]="!category.selected && selectedCount >= maxSelections"
          (click)="toggleCategory(category)"
        >
          <div class="category-icon">
            <i [class]="category.icon || 'fas fa-star'"></i>
          </div>
          <h3>{{category.name}}</h3>
          <p>{{category.description}}</p>
        </div>
      </div>

      <div class="actions">
        <button 
          class="save-btn" 
          (click)="savePreferences()"
          [disabled]="saving || selectedCount === 0"
        >
          <i class="fas fa-save"></i>
          {{saving ? 'Enregistrement...' : 'Enregistrer mes préférences'}}
        </button>
      </div>
    </div>
  </div>
</div> 